import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import './index.css';
import App from './App';
import About from './components/About';
import Sidebar from './components/Sidebar';
import ErrorPage from './pages/error-page';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import '@tabler/icons-webfont/dist/tabler-icons.min.css';
import './i18n';
import navValues from './helpers/navValues';

import {ConfigProvider} from "./helpers/useConfig";

const month = new Date().getMonth() + 1;
const year = new Date().getFullYear();
const lastmonth = (month == 1)? 12 : month - 1;
const yearslastmonth = (month == 1)? year - 1 : year;
const router = createBrowserRouter([
      {
        path: "/",
        element: <App layout=""  />,
        errorElement: <ErrorPage />,
      },
      {
        path: "Now/:nowId",
        element: <App layout={navValues.now}/>,
        errorElement: <ErrorPage />,
      },
      {
        path: "Now",
        element: <App layout={navValues.now}/>,
        errorElement: <ErrorPage />,
      },
      {
        path: "current",
        element: <App layout={navValues.current} />,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "forecast24",
        element: <App layout={navValues.forecast24}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "NextDays",
        element: <App layout={navValues.NextDays}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "AppExternal/:linkID",
        element: <App src="https://v2013.02ws.co.il/small/?section=graph.php&graph=tempLatestArchive.php&profile=1&lang=1&tempunit=&fullt=&s=&c=" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "AppDynExternal",
        element: <App layout={navValues.External} />,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "ForecastAbroad",
        element: <App src="https://v2013.02ws.co.il/small/?section=forecast/getForecast&lang=1" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "ForecastIsrael",
        element: <App src="https://v2013.02ws.co.il/small/?section=forecast/getForecast&region=isr&lang=1" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "ForecastJob",
        element: <App src="https://v2013.02ws.co.il/small/?section=ForecasterJob&lang=1" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "Radar",
        element: <App src="https://v2013.02ws.co.il/small/?section=radar&lang=1" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "Satellite",
        element: <App src="https://v2013.02ws.co.il/satellite.php" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "Rain",
        element: <App src="https://v2013.02ws.co.il/small/?section=graph&graph=rain.php&profile=1&lang=1&style=" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "Runningtreks",
        element: <App src="https://v2013.02ws.co.il/runningtreks.php?lang=1" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "GlobalWarming",
        element: <App src="https://v2013.02ws.co.il/small/?section=globalwarm&lang=1" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "Average",
        element: <App src="https://v2013.02ws.co.il/small/?section=averages&lang=1" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "Last2days",
        element: <App src="https://v2013.02ws.co.il/small/?section=reports/downld02.txt&lang=1" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "LastWeek",
        element: <App src="https://v2013.02ws.co.il/small/?section=reports/downld08.txt&lang=1" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "ThisMonth",
        element: <App src={`https://v2013.02ws.co.il/small/?section=NOAAViewer&month=${month}&year=${year}&lang=1`} layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "ChooseMonthYear",
        element: <App src="https://v2013.02ws.co.il/small/?section=chooseHeader&lang=1" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "LastMonth",
        element: <App src={`https://v2013.02ws.co.il/small/?section=NOAAViewer&month=${lastmonth}&year=${yearslastmonth}&lang=1`} layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "Records",
        element: <App src="https://v2013.02ws.co.il/small/?section=allTimeRecords&lang=1" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "RainSeasons",
        element: <App src="https://v2013.02ws.co.il/small/?section=RainSeasons" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "LoveHateForecasts",
        element: <App src="https://v2013.02ws.co.il/small/?section=forecastDays" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "Reports",
        element: <App src="https://v2013.02ws.co.il/small/?section=reports" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "Archive",
        element: <App src="https://v2013.02ws.co.il/small/?section=browsedate" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "Snow",
        element: <App src="https://v2013.02ws.co.il/small/?section=snow" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "Climate",
        element: <App src="https://v2013.02ws.co.il/small/?section=climate" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "BestSeason",
        element: <App src="https://v2013.02ws.co.il/small/?section=survey&survey_id=1" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "Faq",
        element: <App src="https://v2013.02ws.co.il/small/?section=faq" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },  
      {
        path: "Tips",
        element: <App src="https://v2013.02ws.co.il/small/?section=tips" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },  
      {
        path: "Poems",
        element: <App src="https://v2013.02ws.co.il/small/?section=snowpoetry" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },  
      {
        path: "Weatherclips",
        element: <App src="https://v2013.02ws.co.il/small/?section=weatherclips" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },    
      {
        path: "Songs",
        element: <App src="https://v2013.02ws.co.il/small/?section=songs" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },    
      {
        path: "Myths",
        element: <App src="https://v2013.02ws.co.il/small/?section=myths" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },      
      {
        path: "Forum",
        element: <App src="https://v2013.02ws.co.il/small/?section=chatmobile.php&lang=" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "About",
        element: <About/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "Contact",
        element: <App src="https://v2013.02ws.co.il/small/?section=SendFeedback" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      },
      {
        path: "Radiosonde",
        element: <App src="https://v2013.02ws.co.il/small/?section=radiosonde" layout={navValues.External}/>,
        errorElement: <ErrorPage />,
        
      }
   
  
   
]);

ReactDOM.createRoot(document.getElementById("root")).render(
 
  <React.StrictMode>
      <ConfigProvider>
        <RouterProvider router={router} />
      </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
